<template>
  <v-card
    
    class=" py-8 px-6 text-center"
    elevation="0">
    <v-card-title> ログイン </v-card-title>

    <v-card-text class="mt-4">
      <!-- エラーメッセージ -->
      <v-alert
        v-if="props.error"
        type="error"
        variant="tonal"
        class="mb-8 text-left">
        {{ props.error }}
      </v-alert>

      <v-alert
        v-if="props.msg"
        type="info"
        variant="tonal"
        class="mb-8 text-left">
        {{ props.msg }}
      </v-alert>

      <v-form
        ref="loginForm"
        @submit.prevent="submit">
        <v-text-field
          v-model="email"
          label="メールアドレス"
          variant="outlined"
          :disabled="props.loading"
          clearable
          block>
        </v-text-field>

        <v-text-field
          v-model="password"
          :type="passwordVisible ? 'text' : 'password'"
          :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="passwordVisible = !passwordVisible"
          label="パスワード"
          :disabled="props.loading"
          variant="outlined"
          clearable
          block>
        </v-text-field>

        <!-- v-switch パスワード表示切替 -->

        <v-btn
          :loading="props.loading"
          :disabled="!sendable"
          type="submit"
          class="my-4"
          variant="flat"
          color="primary"
          size="large"
          block>
          ログイン
        </v-btn>

        <v-container class="d-flex justify-end">
          パスワードを忘れた方は
          <a
            href="#"
            @click.prevent.stop="forgot">
            こちら
          </a>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useDisplay } from 'vuetify';

const props = defineProps({
  loading: Boolean,
  error: String,
  msg: String
});

const emit = defineEmits<{
  submit: [email: string, password: string];
  forgot: [];
}>();

const email = ref('');
const password = ref('');
const passwordVisible = ref(false);

const sendable = computed(() => {
  return email.value?.length && password.value?.length;
});

async function submit() {
  emit('submit', email.value, password.value);
}

function forgot() {
  emit('forgot');
}

// const {name} = useDisplay()

// const width = computed(() => {

//   switch (name.value){
//     case 'xs': return 320
//     case 'sm': return 620
//     case 'md': return 820
//     case 'lg': return 1020
//     case 'xl': return 1220
//     case 'xxl': return 1420
//   }

//   return undefined
// })
</script>
